export class CampoSpecificoConservazioneDTO {
  numeroAnni: number;
  termineRiferimento: string;
  dataRiferimento: string;
}
